module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d4H1Y"))).then(() => parcelRequire('f4eak'));